import { render, staticRenderFns } from "./card6.vue?vue&type=template&id=0299c053&scoped=true&"
import script from "./card6.vue?vue&type=script&lang=js&"
export * from "./card6.vue?vue&type=script&lang=js&"
import style0 from "./card6.vue?vue&type=style&index=0&id=0299c053&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0299c053",
  null
  
)

export default component.exports